import { getAppsyncUrl } from "../authenticate";
import { getAuth } from '../../contexts/authStore';
import {getUserPool} from "../pools/pools";

export async function putBug(bugId: string, title: string, description: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `mutation Mutation {
                putBug(bugId: ${JSON.stringify(bugId)}, title: ${JSON.stringify(title)}, description: ${JSON.stringify(description)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putBug)
            })
        })
    }
}